import { Card, Row, Col, Form } from 'react-bootstrap';
import VehicleCardBody from '../../../components/VehicleCardBody/VehicleCardBody';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import RequiredFormLabel from '../../RequiredFormLabel/RequiredFormLabel';
import { useState } from 'react';
import TiassistoElement from '../../TiAssisto/TiassistoElement';

const OpportunityVehicle = ({
  vehicleResponse,
  opportunityResponse,
  values,
  handleChange,
  errors
}) => {
  const [showWarning, setShowWarning] = useState(false);
  const { t } = useTranslation()
  return (
    <Card className="mb-4">
      {opportunityResponse.ID_Vehicle_HMP__c ? (
        <div>
          {vehicleResponse && (
            <div>
              <VehicleCardBody showLinkBtn data={vehicleResponse} showState />
            </div>
          )}
        </div>
      ) : (
        <div>
          {opportunityResponse.Modello__c && (
            <Card.Body>
              <Card.Title>
                <b>{t('vehicle')}</b>
              </Card.Title>
              <Row>
                <Col>
                  <b>{t('brand')}</b>
                  <p>{opportunityResponse.Brand__c || opportunityResponse.Marca__c || i18next.t('not_available')}</p>
                </Col>
                <Col>
                  <b>{t('model')}</b>
                  <p>{opportunityResponse.Modello__c || i18next.t('not_available')}</p>
                </Col>
              </Row>
            </Card.Body>
          )}
        </div>
      )}
      <TiassistoElement>
        <Card.Body>
          <Row>
            {/* Vehicle Plate (Targa) */}
            <Col sm={4} className="pr-4">
              <Form.Group className="mb-3">
                <RequiredFormLabel
                  label={t('vehicle_plate')}
                  required={false}
                  additionalRedLabelText={t('req_die')}
                  className="me-2"
                  htmlFor="targaAnchor"
                  errors={errors}
                />
                <Form.Control
                  id="targaAnchor"
                  type="text"
                  name="targa"
                  onChange={(e) => {
                    const { value } = e.target;
                    if (value.length === 10) {
                      setShowWarning(true);
                    } else {
                      setShowWarning(false);
                    }
                    handleChange(e);
                  }}
                  value={values.targa}
                  maxLength={10}
                />
              </Form.Group>
              {showWarning && <div className="text-danger">{t("licensePlate_no_more_than_10_chars")}</div>}

            </Col>

            {/* Vehicle Frame (Telaio) */}
            <Col sm={4} className="pr-4">
              <Form.Group className="mb-3">
                <RequiredFormLabel
                  label={t('vehicle_frame')}
                  required={false}
                  additionalRedLabelText={t('req_die')}
                  className="me-2"
                  htmlFor="telaioAnchor"
                  errors={errors}
                />
                <Form.Control
                  id="telaioAnchor"
                  type="text"
                  name="telaio"
                  onChange={handleChange}
                  value={values.telaio}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* Drive it easy end contract date */}
            <Col md={4}>
              <Form.Group className="mb-3">
                <RequiredFormLabel
                  label={t('date_end_contract')}
                  required={false}
                  additionalRedLabelText={t('req_die')}
                  className="me-2"
                  htmlFor="dateEndContractAnchor"
                  errors={errors}
                />
                <Form.Control
                  id="dateEndContractAnchor"
                  name="dataFineContrattoDriveItEasy"
                  type="date"
                  value={values.dataFineContrattoDriveItEasy ?? ''}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          {/* <Row>
            <Col md={12}>
              <Form.Group>
                <small className='text-muted'><FaInfoCircle /> Targa e telaio sono richiesti per attivare Drive It Easy</small>
              </Form.Group>
            </Col>
          </Row> */}
        </Card.Body>
      </TiassistoElement>
    </Card>
  );
};

export default OpportunityVehicle;
